import { effect, inject, Injectable, signal } from '@angular/core';

import { AuthService } from './auth.service';

export type Tema = 'oscuro' | 'claro';

const STORAGE_PREFIX = 'cobros_tema';

@Injectable({ providedIn: 'root' })
export class TemaService {
  private readonly auth = inject(AuthService);

  readonly tema = signal<Tema>('claro');

  constructor() {
    this.cargarPreferenciaGuardada();

    effect(() => {
      this.auth.userId();
      this.cargarPreferenciaGuardada();
    });

    effect(() => {
      this.aplicarAlDom(this.tema());
    });
  }

  /** Alterna entre modo noche (oscuro) y modo claro. */
  toggle(): void {
    const nuevo: Tema = this.tema() === 'oscuro' ? 'claro' : 'oscuro';
    this.tema.set(nuevo);
    this.persistir(nuevo);
  }

  esModoNoche(): boolean {
    return this.tema() === 'oscuro';
  }

  private cargarPreferenciaGuardada(): void {
    const key = this.storageKey();
    if (!key) return;
    const guardado = localStorage.getItem(key);
    this.tema.set(guardado === 'oscuro' ? 'oscuro' : 'claro');
  }

  private persistir(tema: Tema): void {
    const key = this.storageKey();
    if (key) localStorage.setItem(key, tema);
  }

  private storageKey(): string | null {
    if (typeof localStorage === 'undefined') return null;
    const id = this.auth.userId();
    return id != null ? `${STORAGE_PREFIX}_u${id}` : `${STORAGE_PREFIX}_guest`;
  }

  private aplicarAlDom(tema: Tema): void {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('tema-claro', tema === 'claro');
    document.body.classList.toggle('tema-oscuro', tema === 'oscuro');
  }
}
